export const initialRowData = {
  company_name: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  // upload_to_autofill: {
  //   column_value: "",
  //   column_type: {
  //     data_type: "file",
  //     color_code: "",
  //     additional_info: "",
  //   },
  // },
  // flow: {
  //   column_value: "",
  //   column_type: {
  //     data_type: "select",
  //     color_code: "",
  //     additional_info: "",
  //   },
  // },
  logistics_provider: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  contents: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  order_status: {
    column_value: "",
    column_type: {
      data_type: "select",
      options: ["Order Placed", "In Transit", "Received"],
      color_code: "",
      additional_info: "",
    },
  },
  progress: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  proforma_invoice_num: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  profo_invoice_date: {
    column_value: "",
    column_type: {
      data_type: "date",
      color_code: "",
      additional_info: "",
    },
  },
  invoice_number: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  invoice_date: {
    column_value: "",
    column_type: {
      data_type: "date",
      color_code: "",
      additional_info: "",
    },
  },
  delivery_date: {
    column_value: "",
    column_type: {
      data_type: "date",
      color_code: "",
      additional_info: "",
    },
  },
  invoice_amount: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  container_tracking: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  eta: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  receivables: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  receivables_status: {
    column_value: "",
    column_type: {
      data_type: "select",
      options: ["Pending", "Paid"],
      color_code: "",
      additional_info: "",
    },
  },
  payables: {
    column_value: "",
    column_type: {
      data_type: "string",
      color_code: "",
      additional_info: "",
    },
  },
  payables_status: {
    column_value: "",
    column_type: {
      data_type: "select",
      options: ["Pending", "Paid"],
      color_code: "",
      additional_info: "",
    },
  },
};
